module.exports = __webpack_public_path__ + "static/media/fundraiser-icon-new.e375b956.png";